import { Account } from '@features/accounts/types';

export const filterAccountsByType = (
  accounts?: Account[],
): { checkingAccount?: Account; savingsAccounts: Account[] } => {
  const checkingAccount = accounts?.find((data) => data.isChecking);
  const savingsAccounts = accounts?.filter((data) => !data.isChecking) ?? [];
  return {
    checkingAccount,
    savingsAccounts,
  };
};
